import { css } from "@emotion/react";
import { useThemeState } from "../../hooks/useThemeState";
import { cn } from "../../lib/utils";

export function CustomScrollbars({
	children,
	className,
}: {
	children?: React.ReactNode;
	className?: string;
}) {
	const themeState = useThemeState();
	const isDarkTheme = themeState.get().themeName === "dark";

	return (
		<div
			className={cn([className])}
			css={css`flex:1 1 0;overflow:auto;color-scheme:${isDarkTheme ? "dark" : "light"};`}
		>
			{children}
		</div>
	);
}
